<div class="powered__container" [ngClass]="caricamento ? 'pt-big' : 'pt-small'">
    Powered by&nbsp;<a href="https://www.cantine.wine" target="_blank">Cantine<span
            class="powered__color">.wine</span></a>
</div>